<div class="search-advanced-items">

  <div class="row row-total row-justify-content-left">
    <div class="info reset-font">
      Create custom Show, Hide and Highlight rules based on Item Class, Base Type, Rarity, and Advanced Conditions.
      These rules have a higher precedence than the Quick Filters, and are processed in the order they are listed.
      The higher the rule, the higher its precedence.
    </div>
  </div>

  <div class="search-advanced-pane full-width">
    <app-custom-rule-groups-list
      [filter]="filter"
      [cosmetic]="false"
      [controller]="groupsCtrl"
      addGroupButtonLabel="Add new Custom Rule Group"
    />
  </div>
</div>
